import { WAVES_MODULES_CONFIG } from "@constants/tabs";
import { ClientContext } from "@context/Client/ClientContext";
import { ClientUIModule } from "@services/api/types";
import { useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";

export type WavesTabsConfig = {
  path: string;
  label: string;
  id: ClientUIModule;
}[];

export const useWavesTabsConfig = (): WavesTabsConfig => {
  const { t } = useTranslation();
  const { currentClient } = useContext(ClientContext);

  const wavesTabs = useMemo(() => {
    const uiModules = currentClient.client.ui_modules || [];
    return Object.keys(WAVES_MODULES_CONFIG)
      .filter((module) => uiModules.includes(WAVES_MODULES_CONFIG[module].id))
      .map((module) => {
        const moduleConfig = WAVES_MODULES_CONFIG[module];
        return {
          ...moduleConfig,
          label: t(moduleConfig.label),
          id: moduleConfig.id
        };
      })
      .sort((a, b) => a.orderId - b.orderId);
  }, [t, currentClient.client.ui_modules]);

  return wavesTabs;
};
